(ns app.front.view.group.admin.inspections.working-areas
  (:require [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag] :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.inspections.subs :as ias]
            [core.front.carbon :as cc]
            [core.front.comm :as comm]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(def available-colours ["#720B4B"
                        "#281D93"
                        "#69B75E"
                        "#964C02"
                        "#FADF07"])


(def opacity "27")


(def colours-for-dropdown (map #(hash-map :text %) available-colours))


(defn- sorted-property-keys [features]
  (->> features
       first
       :properties
       keys
       (filter (fn [k]
                 ; Only allow keys that are in every feature
                 (every? #(-> % :properties (contains? k)) features)))
       sort))


(rf/reg-event-db
  ::shapefile-parsed
  (fn [db [_ filename md5 _ features]]
    (-> (assoc db ::shapefile {:md5               md5
                               :filename          filename
                               :features          features
                               :selected-property (-> features sorted-property-keys first)})
        (dissoc ::shapefile-loading))))


(rf/reg-event-db
  ::set-shapefile-loading
  (fn [db _]
    (assoc db ::shapefile {:loading? true})))


(rf/reg-event-db
  ::set-selected-property
  (fn [db [_ selected-property]]
    (assoc-in db [::shapefile :selected-property] selected-property)))


(rf/reg-event-fx
  ::save-new-features
  (fn [{:keys [db]} [_ group-id]]
    (let [{:keys [md5 filename features selected-property]} (::shapefile db)]
      {:comm/command {:command    :group/add-working-areas
                      :data       {:group-id      group-id
                                   :file/filename filename
                                   :file/md5      md5
                                   :features      (->> features
                                                       (map (fn [feature]
                                                              {:id       (-> feature :id)
                                                               :label    (-> feature :properties selected-property)
                                                               :geometry (-> feature :geometry)})))}
                      :on-success [::save-new-features.success]}
       :db           (dissoc db ::shapefile)})))


(rf/reg-event-fx
  ::save-new-features.success
  (fn [{:keys [db]} [_ _ response]]
    {:dispatch [:notifications/add :toast :success :success ""]
     :db       (update db ::working-areas concat response)}))


(rf/reg-event-fx
  ::fetch-working-areas
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/get-working-areas
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::fetch-working-areas.success]}}))


(rf/reg-event-db
  ::fetch-working-areas.success
  (fn [db [_ _ response]]
    (assoc db ::working-areas response)))


(rf/reg-event-fx
  ::delete-areas
  (fn [_ [_ group-id area-ids]]
    {:comm/command {:command    :group/delete-working-areas
                    :data       {:group-id group-id
                                 :area-ids area-ids}
                    :on-success [::delete-areas.success area-ids]}}))


(rf/reg-event-fx
  ::delete-areas.success
  (fn [{:keys [db]} [_ area-ids _ _]]
    {:dispatch [:notifications/add :toast :success :success ""]
     :db       (update db ::working-areas (fn [areas]
                                            (remove #(contains? area-ids (:id %)) areas)))}))


(rf/reg-event-fx
  ::assign-working-area
  (fn [{:keys [db]} [_ group-id inspector area-id op area-key]]
    {:db           (update db ::working-areas p/update-first {:id area-id} update area-key conj (:user/username inspector))
     :comm/command {:command    :group/assign-working-area
                    :data       {:group-id  group-id
                                 :area-id   area-id
                                 :user-id   (:db/id inspector)
                                 :area-key  area-key
                                 :operation op}
                    :on-success [::assign-working-area.success]}}))


(rf/reg-event-db
  ::assign-working-area.success
  (fn [db [_ _ updated-area]]
    (update db ::working-areas p/assoc-first {:id (:id updated-area)} updated-area)))


(rf/reg-event-fx
  ::set-overlay-colour
  (fn [{:keys [db]} [_ group-id area-ids colour]]
    {:db           (update db
                           ::working-areas
                           #(reduce (fn [areas id]
                                      (p/update-first areas {:id id} assoc :defined-area/overlay-colour colour))
                                    %
                                    area-ids))
     :comm/command {:command    :group/set-map-area-overlay-colour
                    :data       {:group-id group-id
                                 :area-ids area-ids
                                 :colour   colour}
                    :on-success [::set-overlay-colour.success]}}))


(rf/reg-event-fx
  ::set-overlay-colour.success
  (fn [_ _]
    {:dispatch [:notifications/add :toast :success :success ""]}))


(rf/reg-event-db ::clear-shapefile #(dissoc % ::shapefile))


(rf/reg-sub ::shapefile :-> ::shapefile)


(rf/reg-sub
  ::working-areas
  (fn [db _]
    (->> db
         ::working-areas
         (sort-by :defined-area/label))))


(rf/reg-sub
  ::grouped-working-areas
  :<- [::working-areas]
  (fn [areas]
    (->> areas
         (group-by #(str (.getTime (:created %)) "_" (:defined-area/source-file-md5 %)))
         (p/map-vals #(sort-by :defined-area/label %))
         (sort-by first >))))


(rf/reg-sub
  ::addable-areas
  :<- [::working-areas]
  (fn [areas [_ inspector-username]]
    (->> areas
         (remove #(contains? (set (concat (:defined-area/usernames %)
                                          (:defined-area/secondary-usernames %)))
                             inspector-username)))))


(rf/reg-sub
  ::current-areas
  :<- [::working-areas]
  (fn [areas [_ area-key inspector-username]]
    (->> areas
         (filter #(-> % area-key set (contains? inspector-username))))))


(rf/reg-sub
  ::property-keys
  :<- [::shapefile]
  (fn [shapefile]
    (-> shapefile :features sorted-property-keys)))


(rf/reg-sub
  ::inspectors
  :<- [::ias/inspector-groups]
  (fn [groups]
    (->> groups
         (mapcat :user/_groups)
         distinct)))


(defn- add-shape-file [file-id filename md5]
  (comm/send-command-execution
    {:command    :group/parse-shapefile
     :data       {:file-id  file-id
                  :file/md5 md5}
     :on-success [::shapefile-parsed filename md5]}))


(defn inspector-areas [tr group-id inspector area-key]
  (r/with-let [*adding? (r/atom false)]
    (let [current-areas (<sub [::current-areas area-key (:user/username inspector)])
          addable-areas (<sub [::addable-areas (:user/username inspector)])]
      [:div.flex.flex-1.flex-col.inspection-config__inspector-working-areas
       (for-frag [area current-areas]
         [:div.mb-2.mr-4.flex.flex-grow-0.items-center.justify-between.p-2.bg-ui-night-sky.text-white
          {:style {:width "fit-content"}}
          (:defined-area/label area)
          (cc/icon {:icon        i/remove
                    :fill        "white"
                    :description (tr [:remove])
                    :class-name  "cursor-pointer"
                    :on-click    #(>evt [::assign-working-area group-id inspector (:id area) :remove area-key])})])
       [:div {:style {:min-height "40px"}}
        (if @*adding?
          (cc/select
            {:id         (str (:db/id inspector) "-area-select")
             :label-text (tr [:inspection.areas/new-working-area])
             :hide-label true
             :on-change  (fn [e]
                           (reset! *adding? false)
                           (>evt [::assign-working-area
                                  group-id
                                  inspector
                                  (-> e .-target .-value)
                                  :add
                                  area-key]))}
            [ui/placeholder-select-item tr]
            (for-frag [area addable-areas]
              (cc/select-item {:text  (str (:defined-area/label area) " (" (:defined-area/source-filename area) ")")
                               :value (:id area)})))
          (cc/button
            {:kind     :tertiary
             :size     :small
             :disabled (empty? addable-areas)
             :on-click #(reset! *adding? true)}
            (tr [(if (= area-key :defined-area/usernames)
                   :inspection.areas/assign-primary-area
                   :inspection.areas/assign-secondary-area)])))]])))


(defn colour-element [e]
  (let [colour (futil/oget e :text)]
    (r/as-element
      [:div.flex
       [:div {:style {:width            "1rem"
                      :height           "1rem"
                      :background-color (str colour opacity)}}]
       [:div.ml-3 colour]])))


(defn colour-selector [tr group-id area-ids current-colour]
  [:div {:class "w-1/2"}
   [:h5.mt-2 (tr [:inspection.areas/map-overlay-colour])]
   (cc/dropdown {:id                    "overlay-color-menu"
                 :class-name            "w-64 mt-3 select-wide-menu"
                 :label                 (tr [:inspection.areas/select-overlay-colour])
                 :items                 colours-for-dropdown
                 :initial-selected-item (when current-colour
                                          (p/find-first colours-for-dropdown {:text current-colour}))
                 :item-to-string        #(futil/oget % :text)
                 :item-to-element       colour-element
                 :on-change             #(>evt [::set-overlay-colour group-id area-ids (futil/oget % :selectedItem :text)])})
   (when current-colour
     [:div.relative.mt-3 {:style {:max-width "16rem"}}
      [:img {:src "/asset/img/map-sample.jpg"
             :alt (tr [:inspection.areas/map-overlay-sample])}]
      [:div.absolute.top-0.right-0.w-full.h-full
       {:style {:background-color (str current-colour opacity)}}]])])


(defn view [{:keys [tr authority-group-id]}]
  (let [{:keys [features selected-property loading?]} (<sub [::shapefile])
        property-keys                                 (<sub [::property-keys])
        grouped-areas                                 (<sub [::grouped-working-areas])
        inspectors                                    (<sub [::inspectors])]
    [acommon/section
     {}
     (cond
       (seq features)
       [:div
        [:h3 (tr [:inspection.areas/add-shapefile-title])]
        #_{:clj-kondo/ignore [:deprecated-var]}
        [ui-table/responsive-table
         {:tr tr}
         (->> property-keys
              (map (fn [k] {:title k})))
         (->> features
              (map (fn [feature]
                     {:key  (:id feature)
                      :cols (->> property-keys
                                 (map (fn [k]
                                        {:content (-> feature :properties k)})))})))]
        [:div.mt-3
         [ui-select/select {:id           "feature-property-select"
                            :label-text   (tr [:inspection.areas/identifier-property])
                            :required     false
                            :values       property-keys
                            :allow-empty? false
                            :val->str     name
                            :on-change    #(>evt [::set-selected-property %])
                            :value        selected-property}]]
        [:div.flex.justify-end.mt-3
         (cc/button
           {:kind     :tertiary
            :on-click #(>evt [::clear-shapefile])}
           (tr [:cancel]))
         (cc/button
           {:kind     :primary
            :on-click #(>evt [::save-new-features authority-group-id])}
           (tr [:save]))]]

       loading?
       (cc/inline-loading {:description (tr [:inspection.areas/processing-shapefile])
                           :class-name  "mt-10"
                           :success     (not loading?)})

       (not loading?)
       [:div
        [upload/upload-button "shapefile-upload"
         {:attach-file-fn  (fn [file-id filename _ md5]
                             (>evt [::set-shapefile-loading])
                             (add-shape-file file-id filename md5))
          :button-i18n-key :inspection.areas/upload-shapefile
          :accept-types    ["application/zip" "application/x-zip-compressed"]}]])
     (when (seq grouped-areas)
       [:<>
        [:div.mt-6
         [:h3 (tr [:inspection.areas/existing-shapefiles])]
         (for-frag [[shapefile-key areas] grouped-areas
                    :let [area-ids (set (map :id areas))]]
           ^{:key shapefile-key}
           [:div.border.border-solid.border-gray-900.mb-3
            [:div.bg-gray-900.text-white.p-4.flex.justify-between
             [:h4 (str (-> areas first :defined-area/source-filename) ", "
                       ((<sub [::date-util/date-time-fn]) (-> areas first :created)))]
             [ui/modal-confirmation-button
              {:tr                tr
               :id                "delete-shapefile"
               :modal-title       (tr [:inspection.areas/delete-shapefile])
               :trigger-icon-opts {:icon        i/trash
                                   :fill        "white"
                                   :description (tr [:inspection.areas/delete-shapefile])
                                   :class-name  "cursor-pointer ml-3"}
               :no-button-text    (tr [:cancel])
               :yes-button-text   (tr [:delete])
               :on-yes-click      #(>evt [::delete-areas authority-group-id area-ids])}
              [:p (tr [:inspection.areas/delete-shapefile-info])]]]
            [:div.p-4.flex
             [:div {:class "w-1/2"}
              [:h5.mt-2 (tr [:inspection.areas/areas])]
              (for-frag [area areas]
                [:div.my-2 (:defined-area/label area)])]
             [colour-selector tr authority-group-id area-ids (-> areas first :defined-area/overlay-colour)]]])]
        [:div.mt-6
         [:h3 (tr [:inspection.areas/inspectors])]
         #_{:clj-kondo/ignore [:deprecated-var]}
         [ui-table/responsive-table
          {:tr tr}
          [{:title (tr [:user-management/name])}
           {:title (tr [:inspection.areas/primary-areas])}
           {:title (tr [:inspection.areas/secondary-areas])}]
          (->> inspectors
               (mapv (fn [inspector]
                       {:key  (:db/id inspector)
                        :cols [{:content (user-model/full-name inspector)}
                               {:opts    {:class "self-end"}
                                :content [inspector-areas
                                          tr
                                          authority-group-id
                                          inspector
                                          :defined-area/usernames]}
                               {:opts    {:class "self-end"}
                                :content [inspector-areas
                                          tr
                                          authority-group-id
                                          inspector
                                          :defined-area/secondary-usernames]}]})))]]])]))
